import React from 'react';
import { Col, Row } from "react-bootstrap";
import { NewsList } from "../../components/News/NewsList.jsx";
import { StyledSectionHeader, StyledListContainer, StyledListSection } from "../../utils/common-styles";
import { NewsArchivesBlock } from "../../components/Sidebar/News/NewsArchivesBlock.jsx";
import { ReportIssue } from "../../components/Sidebar/General/ReportIssue.jsx";
import { Volunteering } from "../../components/Sidebar/General/Volunteering.jsx";
import { BecomeAMember } from "../../components/Sidebar/General/BecomeAMember.jsx";
import { Helmet } from "react-helmet";
import { UrlFixer } from "../../utils/utils";

export const NewsListPage = () => {

    return (
        <>
            <Helmet>
                <title>News from the Wood - The Friends of Queen's Wood</title>
                <meta name="description" content="Latest news and updates from Queen's Wood" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="News from the Wood - The Friends of Queen\'s Wood" />
                <meta property="og:description" content="Latest news and updates from Queen's Wood" />
                <meta property="og:url" content={`${window.location.origin}`} />
                <meta property="og:image" content={UrlFixer('/assets/og-large-profile.jpg')} />
                <meta name="twitter:title" content="News from the Wood - The Friends of Queen\'s Wood" />
                <meta name="twitter:description" content="Latest news and updates from Queen's Wood" />
                <meta name="twitter:image" content={UrlFixer('/assets/og-large-profile.jpg')} />
            </Helmet>
            <StyledSectionHeader>
                <div className="container">
                    <h1 className="section-title">News from the Wood</h1>
                </div>
            </StyledSectionHeader>
            <StyledListSection>
                <StyledListContainer>
                    <Row>
                        <Col xs={12} md={9}>
                            <p style={{ marginTop: "25px" }}>&nbsp;</p>
                            <NewsList /></Col>
                        <Col xs={12} md={3}>
                            <p style={{ marginTop: "25px" }}>&nbsp;</p>
                            <NewsArchivesBlock />
                            <ReportIssue />
                            <Volunteering />
                            <BecomeAMember />
                        </Col>
                    </Row>
                </StyledListContainer>
            </StyledListSection>
        </>
    )
}
